<div class="flex gap-2">
  <app-pan-button
    color="info"
    icon="edit"
    (click)="params.editCallback(params.data)"
    matTooltip="Edit & view associated roles"
  ></app-pan-button>

  <app-pan-button
    [color]="params.data.is_active ? 'success' : 'danger'"
    icon="swap_horiz"
    (click)="params.toggleCallback(params.data)"
    matTooltip="Toggle API Key"
  ></app-pan-button>
</div>
